import {
  SectorDistribution,
  SectorDistributions,
} from '@terminal/hooks/use-theme-sector-distributions/useIndustrySectorDistributions';
import { getDistributions } from '@terminal/hooks/use-theme-sector-distributions/utils/utils';
import { useEntities } from '@terminal/react-query-hooks/entities/useEntities';
import { useTranslation } from 'react-i18next';

export type { SectorDistribution, SectorDistributions };

const TOP_TAGS = 30;

export const useMSThemeSectorDistributions = ({ tags }: { tags: string[] }) => {
  const { t } = useTranslation(['widget']);

  const topTags = tags.slice(0, TOP_TAGS);
  const {
    data: entities,
    isLoading: isEntitiesLoading,
    isError: isEntitiesError,
  } = useEntities({
    entityTags: topTags,
  });

  const sectorDistributions = getDistributions(entities, t);

  return {
    data: {
      totalCompaniesCount: tags.length,
      sectorDistributions,
    },
    isFetching: isEntitiesLoading,
    isError: isEntitiesError,
  };
};
